if (!customElements.get('bundle-variants')) {
  class ProductBundleVariants extends HTMLElement {
    constructor() {
      super();

      // Bind option select events
      this.querySelectorAll('[data-bundle-variant]').forEach((variant) => {
        variant.addEventListener('click', this.onBundleVariantSelect.bind(this));
      });
    }

    /**
     * onBundleVariantSelect
     * @description Toggles variant switch for bundles
     */
    onBundleVariantSelect(event) {

      let target = event.target;
      if (typeof target.src === 'undefined') {
        target = event.target.querySelector('img');
      }

      let group = target.closest('[data-bundle-variant-group]');
      group.querySelector('.border-black').classList.add('border-black-50');
      group.querySelector('.border-black').classList.remove('border-black');
      target.closest('[data-bundle-variant]').classList.add('border-black');
      target.closest('[data-total-bundle]').querySelector('[data-current-bundle-variant] img').src = target.src;
      target.closest('[data-total-bundle]').querySelector('[data-current-bundle-variant] img').srcset = target.srcset;
      target.closest('[data-total-bundle]').querySelector('[data-current-bundle-variant] span').innerHTML = target.alt;
      this.switchVariant();
    }

    /**
     * switchVariant
     * @description Switches main variant to selected from bundles
     */
    switchVariant() {
      let variantsToSelect = [];
      let bundleGroupArr = this.querySelectorAll('[data-bundle-variant-group]');
      bundleGroupArr.forEach(function(bundleGroup, index){
        let variantsArr = bundleGroup.querySelectorAll('[data-bundle-variant]');
        variantsArr.forEach(function(variant){
          if (variant.classList.contains('border-black')) {
            variantsToSelect.push(variant.dataset.bundleVariantId);
          }
        });
      });
      let variantsSorted = variantsToSelect.sort().join(',');
      if (variantsToSelect !== '') {
        document.querySelector('[data-bundle-options="' + variantsSorted + '"] input').checked = true;
        var event = new Event('change');
        document.querySelector('variant-radios').dispatchEvent(event);
      }
    }

  }

  window.ProductBundleVariants = ProductBundleVariants;
  customElements.define('bundle-variants', ProductBundleVariants);
}
